import { action, makeObservable, observable } from "mobx"

import { LockRewardStore } from "@/domains/lock-rewards/lock-reward-store"
import {
  ClaimEverythingByNftFormat,
  LockRewardSelectionStrategy,
} from "@/domains/lock-rewards/strategies/selection/lock-reward-selection-strategy"
import { rewardsToMultiNftClaimEverythingFormat } from "@/domains/lock-rewards/strategies/selection/rewards-to-claim-format"

export class NftSelectionStrategy implements LockRewardSelectionStrategy<number> {
  selectedNftIds: Set<number> = new Set()

  constructor() {
    makeObservable(this, {
      selectedNftIds: observable,
      toggle: action,
      clear: action,
    })
  }

  toggle(nftId: number): void {
    if (this.selectedNftIds.has(nftId)) {
      this.selectedNftIds.delete(nftId)
    } else {
      this.selectedNftIds.add(nftId)
    }
  }

  clear(): void {
    this.selectedNftIds.clear()
  }

  has(nftId: number): boolean {
    return this.selectedNftIds.has(nftId)
  }

  selected(): number[] {
    return Array.from(this.selectedNftIds)
  }

  filteredSelected(currentRewards: LockRewardStore[]): LockRewardStore[] {
    const selectedRewards =
      this.selectedNftIds.size > 0
        ? currentRewards.filter((reward) => this.selectedNftIds.has(reward.nftId))
        : currentRewards

    return selectedRewards
  }

  toClaimFormat(currentRewards: LockRewardStore[]): Array<ClaimEverythingByNftFormat> {
    const selectedRewards = this.filteredSelected(currentRewards)
    return rewardsToMultiNftClaimEverythingFormat(selectedRewards)
  }

  strategyName(): string {
    return "nft-selection"
  }
}
